export const SbLoginTestIds = {
  newLoginBtn: 'new_login_btn',
  orgAdminLoginBtn: 'orgadmin_login_btn'
} as const;
